import axios from 'axios'
import configs from '@/configs/configs'
import { safe_get } from '@/configs/storage'
import { Notification } from 'element-ui'
// import i18n from "@/plugins/i18n";
const errorHandler = (error) => {
  if (error.response) {
    var error_res = error.response.data
    var errors = ''
    let isNotLogin = false

    for (var key in error_res) {
      if (!error_res.hasOwnProperty(key)) continue
      var obj = error_res[key]
      if (typeof obj != 'string') {
        for (var prop in obj) {
          if (!obj.hasOwnProperty(prop)) continue
          errors =
            errors +
            '<li>' +
            `<strong class="mr-2 ">${key}:</strong>` +
            obj[prop] +
            '</li>'
        }
      } else {
        if (error.response.status !== 403) {
          errors = obj
        }
      }
    }

    switch (error.response.status) {
      case 404:
        // router.push({ name: "ERROR_NOTFOUND" });
        break
      case 403:
        if (error.response.data.code == 'token_not_valid') {
          window.App.$store.dispatch('newToken')
          isNotLogin = true
          setTimeout(() => {
            location.reload()
          }, 1000)
        } else {
          if (!window.location.pathname.includes('dashboard')) {
            Notification.error({
              title: '',
              dangerouslyUseHTMLString: true,
              duration: 5000,
              showClose: true,
              message: `شما دسترسی انجام این عمل را ندارید.`,
              customClass: 'error_msg',
            })
            return
          }
        }

        break
    }

    !isNotLogin &&
      errors &&
      Notification.error({
        title: '',
        dangerouslyUseHTMLString: true,
        duration: 5000,
        showClose: true,
        message: `<ul class="list-disc leading-6">${errors}</ul>`,
        customClass: 'error_msg',
      })
  }
}
const axiosFactory = ({ type = 'json', api = 'v1' } = {}) => {
  let token = safe_get('access_token')
  let baseURL =
    api === 'v1'
      ? configs.api
      : api === 'v2'
        ? configs.api2
        : api === 'v3'
          ? configs.api3
          : configs.api

  const option = {
    baseURL: baseURL,
    timeout: 1000000,
  }
  let authApiOption = {
    ...option,
    responseType: type,
    headers: {
      ...option.headers,
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    withCredentials: false,
    // baseURL: configs.api,
  }

  const defaultInstance = axios.create(option)
  const authInstance = axios.create(authApiOption)

  // Add request interceptor to dynamically set Accept-Language header
  const addLanguageInterceptor = (instance) => {
    instance.interceptors.request.use((config) => {
      try {
        // Import store dynamically to avoid circular dependency
        const store = require('@/store').default
        const currentLocale = store.getters.locale
        const acceptLanguage = currentLocale === 'fa' ? 'fa-ir' : 'en-us'
        config.headers['Accept-Language'] = acceptLanguage
      } catch (error) {
        // Fallback to 'fa-ir' if store is not available
        config.headers['Accept-Language'] = 'fa-ir'
      }
      return config
    })
  }

  addLanguageInterceptor(defaultInstance)
  addLanguageInterceptor(authInstance)

  return {
    default: defaultInstance,
    auth: authInstance,
  }
}

const currentPage = (selectedPage, parameter = '?') => {
  if (selectedPage != undefined) return `${parameter}p=${selectedPage}`
  const page = window.location.href.includes(`?p=`)

  let currentPage = page
    ? `${parameter}p=${window.location.search.split('p=')[1]}`
    : ''
  return currentPage
}

export { axiosFactory, errorHandler, currentPage }
